import Vue from 'vue'
const defaultUserData = {}

/*const Id = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
}*/

const year = new Date().getFullYear()

export default {
	state: {
		userData: defaultUserData,
		allUsers: [],
		currentYear: year,
		rounds: 8
	},
	mutations: {
		loadUserData (state, payload) {
			state.userData = payload
		},
		loadAllUsers (state, payload) {
			state.allUsers = payload
		},
		updateUser(state, payload) {
			const toUpdate = state.allUsers.find(user => user.id === payload.id)
			if (toUpdate) {
				const index = state.allUsers.indexOf(toUpdate)
				Vue.set(state.allUsers, index, payload)
			}
		},
		addGame (state, payload) {
			Vue.set(state.userData.games, payload.gameId, payload.game)
		},
		//add or edit current game in userData (only for instructor)
		editCurrentGame (state, payload) {
			state.userData.currentGame = payload
		}
	},
	actions: { 
		async fetchAllUsers ({commit}) {
			
			commit('clearError')
			commit('setLoading', true)

			const resArr=[]

			try {
				const userDatas = await Vue.$db.collection('userData').get()

				userDatas.forEach(doc => {
					let user = doc.data()
					user.id = doc.id
                    resArr.push(user)
				}) 
				commit('setLoading', false)
				commit('loadAllUsers', resArr)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchUserData ({commit}, payload) {
			
			commit('clearError')
			commit('setLoading', true)

			try {
				const userData = await Vue.$db.collection("userData").doc(payload).get()
				let res = userData.exists ? userData.data() : defaultUserData
				commit('setLoading', false)
				commit('loadUserData', res)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//only for admin
		async addGame ({commit, getters}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const uid = getters.user.uid
			
			try {
				await Vue.$db.collection('userData').doc(uid)
				.set({ games: {[payload.gameId]: payload.game}
				}, {merge: true}) 	
				
				commit('setLoading', false)
				commit('addGame', {gameId: payload.gameId, game: payload.game})
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//only admin (change info about the team)
		async changeUserData({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)			
			
			const id = payload.id
			delete payload.id

			try {
				await Vue.$db.collection('userData').doc(id)
				.set({...payload}, {merge: true})
				
				payload.id = id
				commit('setLoading', false)
				commit('updateUser', payload)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
			}
		},
		//add or edit current game in userData (only for instructor)
		async editCurrentGame ({commit, getters}, payload) {
			commit('clearError')
			commit('setLoading', true)

			try {
				await Vue.$db.collection('userData').doc(getters.userId)
				.set({ currentGame: payload }, {merge: true}) 	
	
				commit('setLoading', false)
				commit('editCurrentGame', payload)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}	
	},
	getters: {
		allUsers (state) {
			return state.allUsers
		},
		teams (state) {
			const teams  = []
			state.allUsers.forEach(team => {
				if (team.gameId  === state.userData.currentGame && team.role !== 'admin') {
					teams.push(team.company)
				}
			})
			return teams
		},
		/*for user data*/
		userData (state) {
			return state.userData
		},
		company (state) {
			return state.userData.company
		},
		gameId (state) {
			return state.userData.gameId
		},
		currentRound (state) {
			return state.userData.currentRound
		},
		currentYear (state) {
			let year = state.currentYear
			if (state.userData.currentRound) {
				year+= state.userData.currentRound - 1
			}
			return year
		},
		currentGame (state) {
			return state.userData.currentGame
		},
		rounds (state) {
			return state.rounds
		}
	}
}